<template>
	<div id="start" class="parallax">
		<div class="parallax__group">
			<div id="start-image">
				<div id="header-image-parallax" class="parallax__layer parallax__layer--back"></div>
				<div class="wrapper">
					<h1>KFZ-Technikerbetrieb seit 1999</h1><br />
				</div>
			</div>
			<div class="content parrallax__layer parallax__layer--base">
				<div class="wrapper">
					<!-- <h1>KFZ-Technikerbetrieb seit 1999</h1> -->
					<p>CarMarkt befindet sich nun an der <b>Oberhausener Straße 213</b> in <b>45476 Mülheim an der Ruhr</b>.</p>
					<p>Wir bieten auch <b>kontaktlose Kartenzahlungen</b> sowie Apple und Google Pay an.</p>
				</div>
			</div>
			<div id="sub-images">
				<div class="sub-image image-1" v-on:click="$router.push('services')">
					<div class="image-wrapper">
						<router-link to="/services" @click.native="$scrollToTop"><i class="fas fa-hammer" style="margin-right: 10px;"></i> Leistungen</router-link>
					</div>
				</div>
				<div class="sub-image image-2" v-on:click="$router.push('location')">
					<div class="image-wrapper">
						<router-link to="/location" @click.native="$scrollToTop"><i class="fas fa-map-marker-alt" style="margin-right: 10px;"></i> Hier finden Sie uns</router-link>
					</div>
				</div>
				<div class="sub-image image-3" v-on:click="$router.push('contact')">
					<div class="image-wrapper">
						<router-link to="/contact" @click.native="$scrollToTop" class="contact"><i class="far fa-envelope" style="margin-right: 10px;"></i>Kontakt</router-link>
					</div>
				</div>
			</div>
			<div class="content">
				<div class="wrapper">
					<p>Nach 15 Jahren in Mülheim Heißen und Essen-Rüttenscheid finden Sie <b>CarMarkt</b> jetzt direkt an der <b>A40</b> (ehemals Opel Einig).</p>
					<p>Über den Inhaber Mark Purushotham:</p>
					<ul>
						<li>staatlich geprüfter KFZ-Techniker</li>
						<li>langjährige Berufserfahrung u.a. bei Fiat und TÜV-Rheinland</li>
						<li>20 Jahre Selbständigkeit</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'Home',
	data() {
		return {
			logoDark: require('@/assets/logo-dark.svg')
		}
	}
}
</script>

<style lang="scss" scoped>
$base-color: #B10B16;
$background-color: #28373B;
$background-color-transparent: rgba(40, 55, 59, 0.9);

h1.large {
	font-size: 32pt;
}

div.content {
	background: #fff;
	padding: 10px;
	font-size: 13pt;
}

ul {
	list-style: none;
	padding: 0;
	margin: 0;

	li {
		margin: 0;
		padding: 0;
		background: $background-color;
		color: #fff;
		padding: 10px 15px;
		margin: 5px 0;
		// &::before {
		// 	content: '- ';
		// }
	}
}

.accent {
	color: $base-color;
}

img.inline-logo {
	height: 22pt;
	margin: 0 5px;
}

#start-image {
	width: 100%;
	height: calc(100vh - 374px);
	min-height: 500px;
	position: relative;

	#header-image-parallax {
		height: 100%;
		background: url('../assets/image-history.jpg');
		background-size: cover;
		background-position: center;//center;
	}
	// border-bottom: 3px solid $base-color;

	@media(max-width: 600px) {
		min-height: 250px;
		height: calc(100vh - 240px);
		max-height: 400px;
	}

	.wrapper {
		position: absolute;
		bottom: 0;
		right: 0;
		left: 0;
		padding-bottom: 25px;

		@media(max-width: 600px) {
			padding-bottom: 0;
		}

		h1, p {
			display: inline-block;
			padding: 10px;
			color: #fff;
			background: $background-color-transparent;
			margin: 0 0 40px 0;
			font-size: 13pt;
			@media(max-width: 600px) {
				width: 100%;
				box-sizing: border-box;
				margin: 0;
			}
		}

		h1 {
			margin-bottom: 10px;
			font-size: 26pt;
			@media(max-width: 600px) {
				font-size: 22pt;
				margin-bottom: 0;
			}
		}
	}
}

#sub-images {

	@media (min-width: 600px) {
		display: flex;
		justify-content: center;
		align-items: stretch;
		height: 265px;
	}

	.sub-image {
		background-size: cover;
		background-position: center;
		position: relative;
		@media (min-width: 600px) {
			flex-grow: 1;
		}

		transition: .25s background-size;
		cursor: pointer;

		.image-wrapper {
			position: absolute;
			top: 0; left: 0; right: 0; bottom: 0;
			display: flex;
			justify-content: center;
			align-items: center;
			background: $background-color-transparent;
			transition: .25s background;
		}

		&.image-1 {
			background-image: url('../assets/image-7.jpg');
		}
		&.image-2 {
			background-image: url('../assets/3d-map.jpg');
		}
		&.image-3 {
			background-image: url('../assets/image-9.jpg');
		}

		a {
			background: transparent;

			padding: 15px 30px;
			color: #fff;
			font-weight: 700;
			text-decoration: none;
			text-transform: uppercase;
			transition: .25s background;
		}

		&:hover {
			.image-wrapper {
				background: rgba(0, 0, 0, 0.5);
			}
			a {
				// color: $base-color;
				background: $background-color-transparent;
			}
		}

		@media (max-width: 599px) {
			height: 125px;
			// border-bottom: 2px solid #fff;
			margin: 10px;

			.image-wrapper {
				background: rgba(0, 0, 0, 0.5);
			}
			a {
				background: $background-color-transparent;
			}

			&:hover {
				.image-wrapper {
					background: $background-color-transparent;
				}
				a {
					background: transparent;
				}
			}
		}
	}
}

@media (min-width: 600px) {
	/*** PARALLAX ***/
	// .parallax {
	// 	height: 500px; /* fallback for older browsers */
	// 	height: 100vh;
	// 	overflow-x: hidden;
	// 	overflow-y: auto;
	// 	-webkit-perspective: 300px;
	// 	perspective: 300px;
	// 	min-height: 500px;
	// }

	// .parallax__group {
	// 	position: relative;
	// 	height: 500px; /* fallback for older browsers */
	// 	height: 100vh;
	// 	-webkit-transform-style: preserve-3d;
	// 	transform-style: preserve-3d;
	// 	min-height: 500px;
	// }

	// .parallax__layer {
	// 	position: absolute;
	// 	top: 0;
	// 	left: 0;
	// 	right: 0;
	// 	bottom: 0;
	// 	overflow: hidden;
	// }

	// .parallax__layer--fore {
	// 	-webkit-transform: translateZ(90px) scale(.7);
	// 	transform: translateZ(90px) scale(.7);
	// 	z-index: 1;
	// }

	// .parallax__layer--base {
	// 	-webkit-transform: translateZ(0);
	// 	transform: translateZ(0);
	// 	z-index: 4;
	// }

	// .parallax__layer--back {
	// 	-webkit-transform: translateZ(-300px) scale(2.5);
	// 	transform: translateZ(-300px) scale(2.5);
	// 	z-index: 3;
	// }

	// .parallax__layer--deep {
	// 	-webkit-transform: translateZ(-600px) scale(3);
	// 	transform: translateZ(-600px) scale(3);
	// 	z-index: 2;
	// }
}
</style>
